import { render, staticRenderFns } from "./OtherItemRelations.vue?vue&type=template&id=115cabd6&scoped=true&"
import script from "./OtherItemRelations.vue?vue&type=script&lang=ts&"
export * from "./OtherItemRelations.vue?vue&type=script&lang=ts&"
import style0 from "./OtherItemRelations.vue?vue&type=style&index=0&id=115cabd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115cabd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow,VSelect,VSpacer})
